import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-32 text-center" data-testid="notfound-page">
      <div className="mono text-[10px] tracking-[0.3em] uppercase grad-text font-bold mb-6">Error · 404</div>
      <h1 className="display text-6xl md:text-7xl font-bold leading-none tracking-tight mb-6">
        <span className="grad-text">Path</span> not found
      </h1>
      <p className="text-lg text-[#0A0E1A]/70 mb-10 max-w-xl mx-auto">
        The page you requested is not part of the Hubinall site architecture. Return to the home page or explore the platform.
      </p>
      <div className="flex gap-3 justify-center">
        <Link to="/" className="grad-bg text-white rounded-full px-6 py-3.5 text-sm font-semibold shadow-[0_14px_40px_-12px_rgba(79,70,229,0.4)]">Return Home</Link>
        <Link to="/platform" className="bg-white rounded-full px-6 py-3.5 text-sm font-semibold border hairline hover:border-[#4F46E5] hover:text-[#4F46E5]">Explore Platform</Link>
      </div>
    </div>
  );
}
